// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"YGL8BD","visible":"_1WnweS","alternateIcon":"UwlUcl"};